import { render } from "./SendResult.vue?vue&type=template&id=17739840&scoped=true&ts=true"
import script from "./SendResult.vue?vue&type=script&lang=ts"
export * from "./SendResult.vue?vue&type=script&lang=ts"

import "./SendResult.vue?vue&type=style&index=0&id=17739840&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17739840"]])

export default __exports__